import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from 'firebase/auth';
import { auth } from '../firebase';

/**
 * Cambia la contraseña de la sesión en curso.
 *
 * La reautenticación no es opcional: `updatePassword` exige un login reciente
 * y falla con `auth/requires-recent-login` si han pasado minutos. Pedir la
 * contraseña actual resuelve las dos cosas a la vez — refresca la sesión y
 * comprueba que quien está al teclado es la persona.
 */
export async function cambiarContrasena(actual: string, nueva: string): Promise<void> {
  const usuario = auth.currentUser;
  if (!usuario?.email) {
    throw new Error('No hay una sesión activa.');
  }

  const credencial = EmailAuthProvider.credential(usuario.email, actual);
  await reauthenticateWithCredential(usuario, credencial);
  await updatePassword(usuario, nueva);

  // El token viejo sigue siendo válido, pero pedir uno fresco deja la sesión
  // alineada con el cambio y es lo que `client.ts` inyectará en la próxima
  // petición.
  await usuario.getIdToken(true);
}

/** Traduce los códigos de Firebase a algo que la persona pueda accionar. */
export function mensajeDeErrorDeContrasena(err: unknown): string {
  const codigo = (err as { code?: string })?.code ?? '';
  switch (codigo) {
    case 'auth/wrong-password':
    case 'auth/invalid-credential':
      return 'La contraseña actual no es correcta.';
    case 'auth/weak-password':
    case 'auth/password-does-not-meet-requirements':
      return 'La contraseña nueva no cumple los requisitos mínimos.';
    case 'auth/too-many-requests':
      return 'Demasiados intentos. Espera unos minutos y vuelve a probar.';
    case 'auth/requires-recent-login':
      return 'Por seguridad, vuelve a iniciar sesión antes de cambiar la contraseña.';
    default:
      return 'No se pudo cambiar la contraseña. Intenta de nuevo.';
  }
}
